import { WebhookConfig, CreateWebhookRequest, WebhookDelivery } from "@/types/webhook";
import { apiJson } from '@/lib/http';

const apiCall = <T = unknown>(endpoint: string, options: RequestInit = {}) => apiJson<T>(endpoint, options);

export const webhookService = {
  async getWebhooks(projectId: string): Promise<WebhookConfig[]> {
    return apiCall(`/Webhook/projects/${projectId}`);
  },
  async createWebhook(projectId: string, request: CreateWebhookRequest): Promise<WebhookConfig> {
    return apiCall(`/Webhook/projects/${projectId}`, {
      method: 'POST',
      body: JSON.stringify(request),
    });
  },
  async deleteWebhook(webhookId: number): Promise<void> {
    await apiCall(`/Webhook/${webhookId}`, {
      method: 'DELETE',
    });
  },
  async getEventTypes(): Promise<string[]> {
    return apiCall('/Webhook/event-types');
  },
  async getDeliveryHistory(webhookId: number, limit: number = 50): Promise<WebhookDelivery[]> {
    return apiCall<WebhookDelivery[]>(`/Webhook/${webhookId}/deliveries?limit=${limit}`);
  },
  async updateWebhook(webhookId: number, updates: Partial<CreateWebhookRequest & { isActive?: boolean }>) {
    return apiCall(`/Webhook/${webhookId}`, {
      method: 'PUT',
      body: JSON.stringify(updates),
    });
  },
}; 